import React from 'react';
import './RadioInput.scss';
import classNames from 'classnames';

/**
 * This component is designed to be controlled by the RadioGroup parent.
 */
interface IRadioInputProps {
  checked?: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  name?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: any;
}

const RadioInput: React.FC<IRadioInputProps> = ({ checked, children, disabled, name, onChange, value }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      (event as any).data = { name, value, submitValues: false };
      onChange?.(event);
    }
  };

  return (
    <span className={classNames('RadioInput', { 'RadioInput-disabled': disabled })}>
      <label>
        <input
          checked={checked}
          disabled={disabled}
          name={name}
          onChange={handleChange}
          readOnly
          type="radio"
          value={value ?? ''}
        />
        <span className="RadioInput-Dot" />
        {children}
      </label>
    </span>
  );
};

export default RadioInput;
